/**
 * Check if an organization name contains "AECOM" (case-insensitive)
 */
export const isAecomOrganization = (organizationName: string | undefined | null): boolean => {
  return organizationName?.toUpperCase().includes('AECOM') ?? false;
};

/**
 * Whether a user signs in with an AECOM address.
 *
 * The gate on the invite flows. Inviting into the organisation is an AECOM
 * action, and every entry point has to agree — a second spelling is how one of
 * them drifts open. Distinct from isAecomOrganization above, which asks about a
 * project's organisation rather than about who is asking.
 *
 * The server still decides whether an invite succeeds. This decides only
 * whether the door is visible, which is what the other call sites do too.
 */
export const isAecomUser = (email: string | undefined | null): boolean =>
  email?.toLowerCase().endsWith('@aecom.com') ?? false;
